export default __webpack_public_path__ + "static/media/bd.8332a402.svg";